import axios from "axios";
import {chunkArray} from "../../utils/Array";

const storefrontProxyUrl = process.env.REACT_APP_STOREFRONT_PROXY_URL;

export async function getStoreSites() {
    let sites = [];

    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/sites`, {
        headers: {'Accept': 'application/json'}
    }).then(response => {
        sites = response.data.data;
    }).catch(console.error);

    return sites;
}

export async function getRedirects(keyword) {
    let redirects = [];
    let totalPages = 1;
    for (let i = 0; i < totalPages; i++) {
        await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/redirects`, {
            params: { keyword, limit: 250, page: (i+1) },
            headers: {'Accept': 'application/json'}
            // eslint-disable-next-line no-loop-func
        }).then(response => {
            redirects.push(...response.data.data);
            totalPages = response.data.meta?.pagination?.total_pages || 1;
        }).catch(console.error);
    }
    return redirects;
}

export async function createRedirectsImportJob(csvFileContents) {
    let importJobId;
    // Prepare the CSV file blob to be sent in form data
    const blob = new Blob([csvFileContents], { type: 'text/csv' });
    const formData = new FormData();
    formData.append('import_file', blob, 'import_file.csv');

    await axios.post(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/redirects/import`, formData).then(response => {
        importJobId = response.data?.id;
    }).catch(console.error);

    return importJobId;
}

export async function deleteRedirects(redirectIdList) {
    for (const redirectIdListSlice of chunkArray(redirectIdList, 200)) {
        await axios.delete(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/redirects`, {
            params: {
                'id:in': redirectIdListSlice.join(',')
            },
            headers: {'Accept': 'application/json'}
        }).then().catch(console.error);
    }
}
